import { render } from "./HomeTeams.html?vue&type=template&id=6e1fa7f2&scoped=true&ts=true&external"
import script from "./HomeTeams.ts?vue&type=script&lang=ts&external"
export * from "./HomeTeams.ts?vue&type=script&lang=ts&external"

import "./HomeTeams.scss?vue&type=style&index=0&id=6e1fa7f2&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1fa7f2"]])

export default __exports__